import { render } from "./App.vue?vue&type=template&id=db74a3be"
const script = {}

import "./App.vue?vue&type=style&index=0&id=db74a3be&lang=css"

import exportComponent from "E:\\waibao\\isa-community-toupin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__